import createLucideIcon from '../createLucideIcon';

const GitCommit = createLucideIcon('GitCommitIcon', [
  ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
  ['line', { x1: '3', y1: '12', x2: '9', y2: '12', key: '1vg2s9' }],
  ['line', { x1: '15', y1: '12', x2: '21', y2: '12', key: 'fnrdho' }],
]);

export default GitCommit;
